const $_default =
{
    currentTime()
    {
        return new Date();
    }
}

const $_validator =
{

}

export default
{
    props:
    {
        miniuteIncrement: { type: Number, default: 5 },
        hour24          : { type: Boolean, default: true },
        secondPicker    : { type: Boolean, default: false },
        currentTime     : { default: $_default.currentTime },
        readonly        : { type: Boolean, default: false }
    }
}